<script>
import { mapGetters } from 'vuex'
import UserEditForm from '@/components/UserEditForm.vue'

export default {
    name: 'AccountProfile',
    components: { UserEditForm },
    computed: {
        ...mapGetters(['userResource'])
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Profile</h4>
            <p class="text-muted mb-0">Manage your personal information and racer details.</p>
        </div>
        <b-card>
            <user-edit-form :user-resource="userResource" submit-text="Save Profile" success-message="Profile Saved!" />
        </b-card>
    </div>
</template>
